import { leadershipImgs, s3Bucket } from ".";

export const techArr = () => [
    {
        name: "Naomi Provost ",
        img: leadershipImgs.naomi,
        title: "Head of Engineering",
    },
    {
        name: "Javiera Canales",
        img: `${s3Bucket}jcanales.jpeg`,
        title: "Data Engineer",
    },
    {
        name: "Griffin Carter",
        img: `${s3Bucket}gcarter.jpg`,
        title: "Data Scientist",
    },
    {
        name: "Wen Tao Lin",
        img: `${s3Bucket}wliu.jpg`,
        title: "Data Scientist",
    },
    { name: "Xinbo Lu", img: `${s3Bucket}xlu.jpg`, title: "Senior Software Engineer" },
];
